<div fxLayout="row"  class="title-notif">
    <h3 class="title ">
        <mat-icon class="notifications-close" (click)="close()">arrow_back</mat-icon>
        <span class="title-large">{{ 'notificationPanel.title' | transloco }}</span>
    </h3>
    <div class="nav-buttons ">
        <span class="read-all" (click)="readAll(selectedTab)"><u class="body-medium">{{ 'notificationPanel.markAsRead' | transloco }}</u></span>
        <mat-icon (click)="openNotificationPreferenceDialog()" class="notification-preference-icon">settings</mat-icon>
    </div>
</div>

<div class="custom-tab-group">
    <div class="custom-tab-labels-box">
        <div class="custom-tab-labels small-view-labels">
            <div class="custom-tab-label " [class.active]="selectedTab === 0" (click)="selectTab(0)">
                <div class="label-text" >
                    <span class="tab-text" >{{ 'notificationPanel.all' | transloco }}</span>
                    <span   class="notif-badge samll-view-badge" *ngIf="unreadNotifs('all')"><b class="label-small">{{unreadNotifs("all")}}</b></span>
                </div>
            </div>
        </div>
        <div class="custom-tab-labels">
            <div class="custom-tab-label hidden-sm-tab-notification" [class.active]="selectedTab === 0" (click)="selectTab(0)">
                <div class="label-text" >
                    <span class="tab-text" >{{ 'notificationPanel.all' | transloco }}</span>
                    <span   class="notif-badge" *ngIf="unreadNotifs('all')"><b class="label-small">{{unreadNotifs("all")}}</b></span>
                </div>

            </div>
            <div class="custom-tab-label" [class.active]="selectedTab === 1" (click)="selectTab(1)">
                <div class="label-text">
                    <span class="tab-text">{{ 'notificationPanel.candidates' | transloco }}</span>
                    <span   class="notif-badge" *ngIf="unreadNotifs('candidate')"><b class="label-small">{{unreadNotifs("candidate")}}</b></span>
                </div>
    
            </div>
            <div class="custom-tab-label" [class.active]="selectedTab === 2" (click)="selectTab(2)">
                <div class="label-text">
                    <span class="tab-text">{{ 'notificationPanel.team' | transloco }}</span>
                    <span   class="notif-badge" *ngIf="unreadNotifs('team')"><b class="label-small">{{unreadNotifs("team")}}</b></span>
                </div>

            </div>
            <div class="custom-tab-label" [class.active]="selectedTab === 3" (click)="selectTab(3)">
                <div class="label-text">
                    <span class="tab-text">{{ 'notificationPanel.system' | transloco }}</span>
                    <span  class="notif-badge"  *ngIf="unreadNotifs('system')"><b class="label-small">{{unreadNotifs("system")}}</b></span>
                </div>

            </div>
            <div class="custom-tab-label" [class.active]="selectedTab === 4" (click)="selectTab(4)">
                <div class="label-text">
                    <span class="tab-text">{{ 'notificationPanel.exams' | transloco }}</span>

                    <span   class="notif-badge" *ngIf="unreadNotifs('exam')"><b class="label-small">{{unreadNotifs("exam")}}</b></span>
                </div>
            </div>
        </div>
    </div>

    <div #scrollableDiv class="custom-tab-content" [@slideInOut]="selectedTab">
        <div *ngIf="selectedTab === 0" class="tab-content">
            <div>
                <app-notification-box *ngIf="emptyNotifList[identifyList(selectedTab)]" [notification]= "emptuNotifFormat" [selectedTab]="selectedTab" ></app-notification-box>
            </div>
            <div *ngFor="let notification of notifs[selectedTab]">
                <app-notification-box [notification] = "notification"></app-notification-box>
            </div>
            <div class="reload-box" *ngIf="!isNotifsListShorter[selectedTab]">
                <mat-icon  class="reload-icon" *ngIf="loadingData" [class.rotate]="loadingData">refresh</mat-icon>
                @if (isNotifsListShort[selectedTab]) {
                    <span class="end-catch-up">{{ 'notificationPanel.seenAll' | transloco }}</span>
                }
                @if (!isNotifsListShort[selectedTab] && !loadingData && !emptyNotifList[identifyList(selectedTab)]) {
                    <span class="read-all" (click)="loadingMore(selectedTab)"><u>{{ 'notificationPanel.showMore' | transloco }}</u></span>
                }
            </div>
        </div>
        <div *ngIf="selectedTab === 1" class="tab-content">
            <div>
                <app-notification-box *ngIf="emptyNotifList[identifyList(selectedTab)]" [notification]= "emptuNotifFormat" [selectedTab]="selectedTab" ></app-notification-box>
            </div>
            <div *ngFor="let notification of notifs[selectedTab]">
                <app-notification-box [notification] = "notification"></app-notification-box>
            </div>
            <div class="reload-box" *ngIf="!isNotifsListShorter[selectedTab]">
                <mat-icon  class="reload-icon" *ngIf="loadingData" [class.rotate]="loadingData">refresh</mat-icon>
                @if (isNotifsListShort[selectedTab]) {
                    <span class="end-catch-up">{{ 'notificationPanel.seenAll' | transloco }}</span>
                }
                @if (!isNotifsListShort[selectedTab] && !loadingData && !emptyNotifList[identifyList(selectedTab)]) {
                    <span class="read-all" (click)="loadingMore(selectedTab)"><u>{{ 'notificationPanel.showMore' | transloco }}</u></span>
                }
            </div>
        </div>
      <div *ngIf="selectedTab === 2" class="tab-content">
        <div>
            <app-notification-box *ngIf="emptyNotifList[identifyList(selectedTab)]" [notification]= "emptuNotifFormat" [selectedTab]="selectedTab"></app-notification-box>
        </div>
        <div 
        *ngFor="let notif of notifs[selectedTab]"
        >
            <app-notification-box [notification]= "notif"></app-notification-box>
        </div>
        <div class="reload-box" *ngIf="!isNotifsListShorter[selectedTab]">
            <mat-icon  class="reload-icon" *ngIf="loadingData" [class.rotate]="loadingData">refresh</mat-icon>
            @if (isNotifsListShort[selectedTab]) {
                <span class="end-catch-up">{{ 'notificationPanel.seenAll' | transloco }}</span>
            }
            @if (!isNotifsListShorter[selectedTab] && !loadingData && !emptyNotifList[identifyList(selectedTab)]) {
                <span class="read-all" (click)="loadingMore(selectedTab)"><u>{{ 'notificationPanel.showMore' | transloco }}</u></span>
            }
        </div>
      </div>
      <div *ngIf="selectedTab === 3" class="tab-content">
        <div>
            <app-notification-box *ngIf="emptyNotifList[identifyList(selectedTab)]" [notification]= "emptuNotifFormat" [selectedTab]="selectedTab"></app-notification-box>
        </div>
        <div 
        *ngFor="let notif of notifs[selectedTab]"
        >
            <app-notification-box [notification]= "notif"></app-notification-box>
        </div>
        <div class="reload-box" *ngIf="!isNotifsListShorter[selectedTab]">
            <mat-icon  class="reload-icon" *ngIf="loadingData" [class.rotate]="loadingData">refresh</mat-icon>
            @if (isNotifsListShort[selectedTab]) {
                <span class="end-catch-up">{{ 'notificationPanel.seenAll' | transloco }}</span>
            }
            @if (!isNotifsListShort[selectedTab] && !loadingData && !emptyNotifList[identifyList(selectedTab)]) {
                <span class="read-all" (click)="loadingMore(selectedTab)"><u>{{ 'notificationPanel.showMore' | transloco }}</u></span>
            }
        </div>
      </div>
      <div *ngIf="selectedTab === 4" class="tab-content">
            <div>
                <app-notification-box *ngIf="emptyNotifList[identifyList(selectedTab)]" [notification]= "emptuNotifFormat" [selectedTab]="selectedTab"></app-notification-box>
            </div>
            <div 
            *ngFor="let notif of notifs[selectedTab]"
            >
                <app-notification-box [notification]= "notif"></app-notification-box>
            </div>
            <div class="reload-box" *ngIf="!isNotifsListShorter[selectedTab]">
                <mat-icon  class="reload-icon" *ngIf="loadingData" [class.rotate]="loadingData">refresh</mat-icon>
                @if (isNotifsListShort[selectedTab]) {
                    <span class="end-catch-up">{{ 'notificationPanel.seenAll' | transloco }}</span>
                }
                @if (!isNotifsListShort[selectedTab] && !loadingData && !emptyNotifList[identifyList(selectedTab)]) {
                    <span class="read-all" (click)="loadingMore(selectedTab)"><u>{{ 'notificationPanel.showMore' | transloco }}</u></span>
                }
            </div>
      </div>
    </div>
</div>
